import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  loading?: boolean;
  onConfirm: () => void;
};

export const ConfirmDeleteInvoiceDialog = ({ loading, onConfirm }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('common:draft.deleteModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('common:draft.deleteModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Trash" loading={loading} onClick={onConfirm}>
          {t('common:draft.deleteModal.submit')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
